// client/src/services/combos.service.js — POS-COMBOS-C1A-DOMAIN-001
import FirebaseService from './firebase.service';

class CombosService extends FirebaseService {
  constructor() {
    super('/combos');
  }

  async listar(params = {}) {
    const data = await this.get('', params);
    return this.ensureArray(data);
  }

  async obtenerPorId(id) {
    return this.ensureObject(await this.get(`/${id}`));
  }

  async preview(payload) {
    return this.ensureObject(await this.post('/preview', payload));
  }

  async crear(payload) {
    return this.ensureObject(await this.post('', payload));
  }

  async actualizar(id, payload) {
    return this.ensureObject(await this.put(`/${id}`, payload));
  }

  async activar(id) {
    return this.ensureObject(await this.post(`/${id}/activar`, {}));
  }

  async desactivar(id) {
    return this.ensureObject(await this.post(`/${id}/desactivar`, {}));
  }

  async archivar(id) {
    return this.ensureObject(await this.delete(`/${id}`));
  }

  /** Combos active para Punto de Venta (stock virtual si hay sucursal). */
  async buscarActivosPv(termino, sucursalId = null) {
    const params = {};
    if (termino) params.q = termino;
    if (sucursalId) params.sucursal_id = sucursalId;
    const data = await this.get('/activos-pv', params);
    return this.ensureArray(data);
  }
}

const combosService = new CombosService();
export default combosService;
